fragment WidgetFragmentFull on Widget {
    id
    name
    type
    isCollapsedForUser
    isHidden
    location
    position
    isRequired
    isEditable
    isDisabledByAdmin
    ... on CustomCustomFieldsWidget {
        customCustomFields {
            id
            attribute {
                name
                displayType
            }
        }
    }
}
